module.exports = __webpack_public_path__ + "static/media/placeholder.5a888265.jpg";